import { cn } from '@eliadmin/core/src/utils/style-utils';

export const Heading = ({
  subtitle,
  title,
  className,
}: {
  subtitle?: string;
  title?: string;
  className?: { line?: string; subtitle?: string; title?: string; container?: string };
}) => {
  return (
    <div className={cn('flex flex-col gap-3', className?.container)}>
      <div className={cn('flex items-center justify-start gap-3')}>
        <div className={cn('h-[1px] w-10 bg-primary', className?.line)} />
        {subtitle && (
          <h3
            className={cn(
              'font-heading text-xl font-normal uppercase text-primary sm:text-2xl',
              className?.subtitle,
            )}
          >
            {subtitle}
          </h3>
        )}
      </div>
      <h2
        className={cn(
          'font-heading text-3xl font-medium uppercase text-foreground sm:text-4xl lg:text-5xl leading-tight sm:leading-snug lg:leading-snug',
          className?.title,
        )}
      >
        {title}
      </h2>
    </div>
  );
};
